<header>
    <div class="container">
        <nav class="navbar">
            <a class="navbar-brand" href="/">
                <img alt="DeltaWizard.ai" height="34" src="assets/images/logo.svg">
            </a>
            <a class="nav-link link-account">
                <img src="assets/images/icon-account.svg" />
            </a>
            <button #btnShowMenu (click)="showMenu = !showMenu" class="navbar-toggler" type="button">
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
                <span class="navbar-toggler-bar"></span>
            </button>
            <div #menu [ngClass]="{ 'show': showMenu, 'navbar-collapse': true, 'collapse':true }">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/projects">Projects</a>
                    </li>
                    <li *ngIf="showCacheClearBtn" (click)="clearCacheAndReload()" class="nav-item">
                        <a class="nav-link" >Clean cache and reload</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/Accout/Logout">Logout</a>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</header>
